export default __webpack_public_path__ + "media/color/wax-e0dbe1de.svg";